<template>
  <div class="h-full">
    <el-row :gutter="10" class="h-full">
      <el-col :span="12" class="h-full">
        <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
          <el-row>
            <selectStandardId @updateStandardId="updateStandardId" />
            <el-input
              v-model="search.name"
              placeholder="类别代码/名称"
              class="w-200px ml-10px mr-10px"
              size="small"
              clearable
            ></el-input>
            <el-button type="primary" size="small" @click="searchClass">{{
              $t('search')
            }}</el-button>
            <el-button size="small" @click="resetClass">{{ $t('reset') }}</el-button>
            <el-button
              type="primary"
              size="small"
              :disabled="!$hasAccess('create')"
              @click="openClassDialog('add')"
              >{{ $t('create') }}</el-button
            >
            <el-button
              type="danger"
              size="small"
              :disabled="!$hasAccess('delete')"
              @click="deleteClass(classSelectList)"
              >{{ $t('delete') }}</el-button
            >
            <!-- <el-button size="small" :disabled="!$hasAccess('export')">{{ $t('export') }}</el-button>
            <el-button size="small" :disabled="!$hasAccess('import')" @click="importClass">{{
              $t('import')
            }}</el-button> -->
          </el-row>
          <el-table
            border
            :data="classTableData"
            v-loading="classTableLoading"
            :highlight-current-row="true"
            height="calc(100% - 104px)"
            class="mt-20px"
            ref="classTable"
            @selection-change="classSelectionChange"
            @row-click="clickClassRow"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="序号" width="60">
              <template slot-scope="scope">
                {{ scope.$index + 1 + (classPage.pageNo - 1) * classPage.pageSize }}
              </template>
            </el-table-column>
            <el-table-column
              label="类别代码"
              prop="classCode"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="类别名称"
              prop="className"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="规则个数"
              prop="ruleCount"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="审批策略"
              prop="stategyName"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button size="mini" @click.stop="openClassDialog('read', scope.row)"
                  >查看</el-button
                >
                <el-button
                  :disabled="!$hasAccess('update')"
                  size="mini"
                  @click.stop="openClassDialog('update', scope.row)"
                  >编辑</el-button
                >
                <el-button
                  size="mini"
                  :disabled="!$hasAccess('delete')"
                  @click="deleteClass([scope.row.id])"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="mt-20px float-right"
            background
            @current-change="classCurrentChange"
            @size-change="classSizeChange"
            :current-page.sync="classPage.pageNo"
            :page-size="classPage.pageSize"
            :page-sizes="$pageSizeAll"
            layout="total, sizes, prev, pager, next, jumper"
            :total="classPage.total"
          ></el-pagination>
        </el-card>
      </el-col>
      <el-col :span="12" class="h-full">
        <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
          <el-input
            class="w-200px mr-10px"
            v-model="attrSearch.name"
            size="small"
            placeholder="属性编码/名称"
            clearable
          >
          </el-input>
          <el-select
            class="w-200px mr-10px"
            v-model="attrSearch.type"
            placeholder="规则类别"
            filterable
            clearable
          >
            <el-option
              v-for="(item, index) in ruleClassList"
              :key="index"
              :label="item.displayName"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-button type="primary" @click="searchAttr">搜索</el-button>
          <el-button @click="resetAttr">重置</el-button>
          <el-button
            type="primary"
            :disabled="!$hasAccess('create') || classTableData.length === 0"
            @click="openAttrDialog('add')"
            >新增</el-button
          >
          <el-button
            type="danger"
            :disabled="!$hasAccess('delete') || classTableData.length === 0"
            @click="delAttr(attrSelectList)"
            >删除</el-button
          >
          <el-button
            type="primary"
            :disabled="!$hasAccess('addTo') || classTableData.length === 0"
            @click="openAddDialog"
            >添加到</el-button
          >
          <el-table
            border
            :data="attrTableData"
            v-loading="attrTableLoading"
            :highlight-current-row="true"
            height="calc(100% - 104px)"
            class="mt-20px"
            ref="fieldTable"
            @selection-change="attrSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="序号" width="60">
              <template slot-scope="scope">
                {{ scope.$index + 1 + (attrPage.pageNo - 1) * attrPage.pageSize }}
              </template>
            </el-table-column>
            <el-table-column
              label="属性编码"
              prop="classAttributeCode"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="属性名称"
              prop="classAttributeName"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="规则类别"
              prop="ruleName"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="数据标签"
              prop="dataLabelName"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button size="mini" @click="openAttrDialog('read', scope.row)">查看</el-button>
                <el-button
                  :disabled="!$hasAccess('update')"
                  size="mini"
                  @click="openAttrDialog('update', scope.row)"
                  >编辑</el-button
                >
                <el-button
                  size="mini"
                  :disabled="!$hasAccess('delete')"
                  @click="delAttr([scope.row.id])"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="mt-20px float-right"
            background
            @current-change="attrCurrentChange"
            @size-change="attrSizeChange"
            :current-page.sync="attrPage.pageNo"
            :page-size="attrPage.pageSize"
            :page-sizes="$pageSizeAll"
            layout="total, sizes, prev, pager, next, jumper"
            :total="attrPage.total"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <!-- 新增实体策略 -->
    <el-dialog
      :title="$t(`${classDialogTitle}`)"
      :visible.sync="classDialogVisible"
      class="mini-dialog"
      :close-on-click-modal="false"
      :before-close="closeClassDialog"
      v-dialogDrag
    >
      <el-form label-width="150px" :model="classForm" ref="classForm" :rules="classFormRules">
        <el-form-item label="过滤无规则实体" prop="filter_rule">
          <el-radio-group
            v-model="classForm.filter_rule"
            size="small"
            @change="getClassList"
            :disabled="classDialogTitle !== '新增'"
          >
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="实体名称" prop="classId">
          <el-select
            v-model="classForm.classId"
            clearable
            filterable
            placeholder="请选择"
            size="small"
            :disabled="classDialogTitle !== '新增'"
          >
            <el-option
              v-for="item in classList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规则" prop="stategy">
          <el-select
            v-model="classForm.stategy"
            clearable
            filterable
            placeholder="请选择"
            size="small"
            :disabled="classDialogTitle === '查看'"
          >
            <el-option
              v-for="(item, index) in stategyList"
              :key="index"
              :label="item.item2"
              :value="item.item1"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="工作流"
          prop="flowId"
          :rules="_.includes([0, 1], classForm.stategy) ? worlflowRule : []"
        >
          <el-select
            v-model="classForm.flowId"
            clearable
            filterable
            placeholder="请选择"
            size="small"
            :disabled="classDialogTitle === '查看'"
          >
            <el-option
              v-for="item in workflowList"
              :key="item.Id"
              :label="item.FlowName"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" v-if="classDialogTitle !== '查看'">
        <el-button @click="closeClassDialog">{{ `${$t('Cancel')}` }}</el-button>
        <el-button type="primary" @click="saveClassForm">{{ `${$t('save')}` }}</el-button>
      </div>
    </el-dialog>

    <!-- 新增属性规则 -->
    <el-dialog
      :title="$t(`${attrDialogTitle}`)"
      :visible.sync="attrDialogVisible"
      class="small-dialog"
      :close-on-click-modal="false"
      :before-close="closeAttrDialog"
      v-dialogDrag
    >
      <el-form label-width="150px" :model="attrForm" ref="attrForm" :rules="attrFormRules">
        <el-form-item label="属性名称" prop="classAttributeId">
          <el-select
            v-model="attrForm.classAttributeId"
            clearable
            filterable
            placeholder="请选择"
            size="small"
            :disabled="attrDialogTitle === '查看'"
          >
            <el-option
              v-for="item in attributeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规则类型" prop="type">
          <el-select
            v-model="attrForm.type"
            clearable
            filterable
            placeholder="请选择"
            size="small"
            :disabled="attrDialogTitle === '查看'"
            @change="changeRuleType"
          >
            <el-option
              v-for="item in ruleClassList"
              :key="item.id"
              :label="item.displayName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规则描述">
          <el-input
            v-model="attrForm.ruleDescription"
            size="small"
            placeholder="请输入规则描述"
            type="textarea"
            :disabled="attrDialogTitle === '查看'"
          ></el-input>
        </el-form-item>
        <!--规则类型为【规范检查】时，显示规则正则-->
        <el-form-item label="规则正则" prop="content" v-if="typeName === '规范检查'">
          <el-select
            class="w-full"
            v-model="attrForm.content"
            placeholder="请选择"
            filterable
            clearable
            :disabled="attrDialogTitle === '查看'"
          >
            <el-option
              v-for="(item, index) in regularList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据标签">
          <el-select
            v-model="attrForm.dataLabelId"
            placeholder="请选择"
            filterable
            clearable
            :disabled="attrDialogTitle === '查看'"
          >
            <el-option
              v-for="item in dataLabelList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="attrForm.enableStatus" :disabled="attrDialogTitle === '查看'">
            <el-radio :label="0">启用</el-radio>
            <el-radio :label="1">未启用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" v-if="attrDialogTitle !== '查看'">
        <el-button @click="closeAttrDialog">{{ `${$t('Cancel')}` }}</el-button>
        <el-button type="primary" @click="saveAttrForm">{{ `${$t('save')}` }}</el-button>
      </div>
    </el-dialog>

    <!--添加到-->
    <el-dialog
      :title="$t('添加到任务')"
      :visible.sync="dialogTask"
      width="70%"
      :close-on-click-modal="false"
      v-dialogDrag
    >
      <el-table
        ref="taskTable"
        :data="taskData"
        height="500"
        border
        highlight-current-row
        @row-click="rowClick"
        @selection-change="handleSelectionChange"
        v-loading="taskLoading"
      >
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column
          type="index"
          width="55"
          :label="$t('seqNo')"
          align="center"
        ></el-table-column>
        <el-table-column prop="name" :label="$t('title')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="runStatus" :label="$t('runningStatus')" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ _.get(_.find(runStatusList, { id: scope.row.runStatus }), 'name') }}
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="executionFrequency"
          :label="$t('frequencyOfExecution')"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="lastRunTime"
          :label="$t('lastRunTime')"
          width="160"
        ></el-table-column>
        <el-table-column prop="lastRunStatus" :label="$t('lastRunStatus')" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ _.get(_.find(runStatusList, { id: scope.row.lastRunStatus }), 'name') }}
          </template>
        </el-table-column>
        <el-table-column
          prop="lastRunTakeTime"
          :label="$t('elapsedLastRunSeconds')"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="nextRunTime"
          :label="$t('nextRunTime')"
          width="160"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <el-row class="mt-20px">
        <el-pagination
          class="r"
          background
          @size-change="taskSizeChange"
          @current-change="taskNoChange"
          :current-page="taskpage.pageNo"
          :page-sizes="$pageSizeAll"
          :page-size="taskpage.pageSize"
          layout="->, total, sizes, prev, pager, next"
          :total="taskpage.total"
        ></el-pagination>
      </el-row>
      <el-row slot="footer">
        <el-button type="primary" size="small" @click="saveTaskData">{{ $t('save') }}</el-button>
        <el-button size="small" @click="dialogTask = false">{{ $t('cancel') }}</el-button>
      </el-row>
    </el-dialog>

    <!-- 导入 -->
    <wiz-upload-file
      v-dialogDrag
      @refreshList="searchClass"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
    ></wiz-upload-file>
  </div>
</template>

<script>
import QualityTaskService from '@/services/QualityTaskService'
import dataLabelManagementService from '@/services/dataLabelManagementService'
import stdClassListService from '@/services/stdClassListService'
import dataRuleSettingService from '@/services/DataRuleSettingService'
import fnMixin from '@/assets/js/fnMixins'
import selectStandardId from '../../components/selectStandardId'

export default {
  name: 'dataRuleSetting',
  mixins: [fnMixin],
  components: {
    selectStandardId,
  },
  data() {
    return {
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 0, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      search: {
        name: '',
        stdId: localStorage.getItem('standardId'), // 选择的库
      },
      classTableData: [],
      classTableLoading: false,
      classSelectList: [],
      classPage: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      currentClassRow: {},
      classDialogVisible: false,
      classDialogTitle: '',
      classForm: {
        filter_rule: false,
        classId: '',
        stategy: '',
        flowId: '',
        id: '',
      },
      classFormRules: {
        filter_rule: [{ required: true, message: '请选择是否过滤无规则实体', trigger: 'change' }],
        classId: [{ required: true, message: '请选择实体名称', trigger: 'blur' }],
        stategy: [{ required: true, message: '请选择规则', trigger: 'blur' }],
      },
      worlflowRule: [{ required: true, message: '请选择工作流', trigger: 'blur' }],
      attrTableData: [],
      attrTableLoading: false,
      attrSelectList: [],
      attrPage: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      attrSearch: {
        name: '',
        type: '',
      },
      attrDialogVisible: false,
      attrDialogTitle: '',
      attrForm: {
        classAttributeId: '',
        type: '',
        ruleDescription: '',
        content: '',
        dataLabelId: '',
        enableStatus: 0,
        id: '',
      },
      attrFormRules: {
        classAttributeId: [{ required: true, message: '请选择属性名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择规则类型', trigger: 'blur' }],
        content: [{ required: true, message: '请选择规则正则', trigger: 'blur' }],
      },
      ruleClassList: [], // 规则类别
      classList: [], // 实体列表
      stategyList: [], // 规则列表
      categoryList: [], // 流程分类列表
      workflowList: [], // 工作流列表
      attributeList: [], // 属性列表
      regularList: [], // 规则正则列表
      dataLabelList: [], // 数据标签列表
      typeName: '',
      dialogTask: false,
      taskData: [],
      taskLoading: false,
      taskpage: {
        pageNo: 0,
        pageSize: 15,
        total: 0,
      },
      checkList: [],
      runStatusList: [
        { id: 0, name: '执行成功' },
        { id: 1, name: '执行失败' },
        { id: 2, name: '取消执行' },
        { id: 3, name: '待执行' },
        { id: 4, name: '暂停' },
        { id: 5, name: '执行中' },
        { id: 6, name: '执行完成' },
        { id: 7, name: '运行中' },
      ],
    }
  },
  created() {
    this.getRuleClassList()
    this.searchClass()
  },
  activated() {
    this.search.stdId = localStorage.getItem('standardId')
  },
  methods: {
    async searchClass() {
      const res = await dataRuleSettingService.getApprovalStategy({
        standardId: this.search.stdId,
        filter: this.search.name,
        skipCount: (this.classPage.pageNo - 1) * this.classPage.pageSize,
        maxResultCount: this.classPage.pageSize,
      })
      if (res && res.code === 0) {
        this.classTableData = res.data
        this.classPage.total = res.totalCount
        if (this.classTableData.length > 0) {
          this.$nextTick(() => {
            this.currentClassRow = res.data[0]
            this.$refs.classTable.setCurrentRow(this.currentClassRow)
            this.searchAttr()
          })
        }
      }
    },
    resetClass() {
      this.search = this.$options.data().search
      this.searchClass()
    },
    classCurrentChange(num) {
      this.classPage.pageNo = num
      this.searchClass()
    },
    classSizeChange(size) {
      this.classPage.pageSize = size
      this.searchClass()
    },
    async openClassDialog(type, row) {
      await this.getClassList()
      await this.getStategyList()
      await this.getWorkflowList()
      if (type === 'add') {
        this.classDialogTitle = '新增'
      } else if (type === 'update') {
        this.classDialogTitle = '编辑'
      } else {
        this.classDialogTitle = '查看'
      }
      if (type !== 'add') {
        _.assign(this.classForm, _.pick(row, ['id', 'classId', 'stategy', 'flowId']))
      }
      this.classDialogVisible = true
    },
    closeClassDialog() {
      this.$refs.classForm.resetFields()
      this.classForm = this.$options.data().classForm
      this.classDialogVisible = false
    },
    saveClassForm() {
      this.$refs.classForm.validate(async (valid) => {
        if (valid) {
          // 移除 filter_rule 字段
          delete this.classForm.filter_rule
          if (this.classForm.id) {
            const res = await dataRuleSettingService.updateApprovalStategy(this.classForm)
            if (res && res.code === 0) {
              this.$message.success('修改成功')
              this.searchClass()
              this.closeClassDialog()
            }
          } else {
            const res = await dataRuleSettingService.addApprovalStategy(this.classForm)
            if (res && res.code === 0) {
              this.$message.success('新增成功')
              this.searchClass()
              this.closeClassDialog()
            }
          }
        }
      })
    },
    deleteClass(ids) {
      if (ids.length) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const res = await dataRuleSettingService.deleteApprovalStategy(ids)
          if (res && res.code === 0) {
            this.$message.success('删除成功')
            this.searchClass()
          }
        })
      } else {
        this.$message.info('请选择需要删除的数据')
      }
    },
    async searchAttr() {
      this.attrTableLoading = true
      const res = await dataRuleSettingService.getQualityRuleList({
        standardId: this.search.stdId,
        keyword: this.attrSearch.name,
        classId: this.currentClassRow.classId,
        ruleId: this.attrSearch.type,
        skipCount: this.attrPage.pageSize * (this.attrPage.pageNo - 1),
        maxResultCount: this.attrPage.pageSize,
      })
      this.attrTableLoading = false
      if (res && res.code === 0) {
        this.attrTableData = res.data
        this.attrPage.total = res.totalCount
      }
    },
    resetAttr() {
      this.attrSearch = this.$options.data().attrSearch
      this.searchAttr()
    },
    attrCurrentChange(num) {
      this.attrPage.pageNo = num
      this.searchAttr()
    },
    attrSizeChange(size) {
      this.attrPage.pageSize = size
      this.searchAttr()
    },
    async openAttrDialog(type, row) {
      await this.getRegularList()
      await this.getDataLabelList()
      await this.getAttrList()
      if (type === 'add') {
        this.attrDialogTitle = '新增'
      } else if (type === 'update') {
        this.attrDialogTitle = '编辑'
      } else {
        this.attrDialogTitle = '查看'
      }
      if (type !== 'add') {
        this.getRuleDetail(row)
      }
      this.attrDialogVisible = true
    },
    // 获取规则详情
    async getRuleDetail(row) {
      const res = await dataRuleSettingService.getRuleDetail({ id: row.id })
      if (res && res.code === 0) {
        _.assign(
          this.attrForm,
          _.pick(res.data, [
            'id',
            'classAttributeId',
            'type',
            'content',
            'dataLabelId',
            'enableStatus',
          ])
        )
        this.attrForm.ruleDescription = row.ruleDescription
        this.typeName = _.get(_.find(this.ruleClassList, { id: this.attrForm.type }), 'displayName')
      }
    },
    saveAttrForm() {
      this.$refs.attrForm.validate(async (valid) => {
        if (valid) {
          if (this.attrForm.id) {
            const res = await dataRuleSettingService.update({
              model: {
                description: this.attrForm.ruleDescription,
                enableStatus: this.attrForm.enableStatus,
                type: this.attrForm.type,
                content: this.attrForm.content,
                classId: this.currentClassRow.classId,
                classAttributeId: this.attrForm.classAttributeId,
                dataLabelId: this.attrForm.dataLabelId,
                id: this.attrForm.id,
              },
            })
            if (res && res.code === 0) {
              this.$message.success('修改成功')
              this.searchAttr()
              this.closeAttrDialog()
            }
          } else {
            const params = {
              description: this.attrForm.ruleDescription,
              enableStatus: this.attrForm.enableStatus,
              type: this.attrForm.type,
              content: this.attrForm.content,
              classInfos: [
                {
                  classId: this.currentClassRow.classId,
                  classAttributeId: this.attrForm.classAttributeId,
                  dataLabelId: this.attrForm.dataLabelId,
                },
              ],
            }
            const res = await dataRuleSettingService.createList(params)
            if (res && res.code === 0) {
              this.$message.success('新增成功')
              this.searchAttr()
              this.$set(this.currentClassRow, 'ruleCount', this.currentClassRow.ruleCount + 1)
              this.closeAttrDialog()
            }
          }
        }
      })
    },
    closeAttrDialog() {
      this.$refs.attrForm.resetFields()
      this.attrForm = this.$options.data().attrForm
      this.attrDialogVisible = false
    },
    delAttr(ids) {
      if (ids.length) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const res = await dataRuleSettingService.remove(ids)
          if (res && res.code === 0) {
            this.$message.success('删除成功')
            this.searchAttr()
          }
        })
      } else {
        this.$message.info('请选择需要删除的数据')
      }
    },
    updateStandardId(val) {
      this.search.stdId = val
      this.searchClass()
    },
    classSelectionChange(val) {
      this.classSelectList = _.map(val, (item) => {
        return item.id
      })
    },
    attrSelectionChange(val) {
      this.attrSelectList = _.map(val, (item) => {
        return item.id
      })
    },
    // 获取字典
    async getDic() {
      const res = await dataRuleSettingService.getDic({
        code: 'DATARULETYPE',
      })
      if (res && res.code === 0) {
        return _.head(res.data) || {}
      }
      return {}
    },
    // 获取规则类别列表
    async getRuleClassList() {
      const dic = await this.getDic()
      if (!_.isEmpty(dic)) {
        const res = await dataRuleSettingService.getRuleClass({
          skipCount: 0,
          maxResultCount: 999,
          dataCategoryId: dic.id,
        })
        if (res && res.code === 0) {
          this.ruleClassList = res.data
        }
      }
    },
    // 获取实体列表
    async getClassList() {
      const parameter = {
        standard_id: this.search.stdId,
        data_type: 1,
        approve_status: 1,
        filter_rule: this.classForm.filter_rule,
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0 && res.data) {
        this.classList = res.data.filter((item) => {
          return !['Tag', 'Document'].includes(item.code)
        })
      }
    },
    // 获取规则正则下拉
    async getRegularList() {
      const res = await dataRuleSettingService.getRegularList()
      if (res && res.code === 0) {
        this.regularList = res.data
      }
    },
    // 获取数据标签下拉数据
    async getDataLabelList() {
      const res = await dataLabelManagementService.list()
      if (res && res.code === 0) {
        this.dataLabelList = res.data
      }
    },
    importClass() {
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    exportTemplate() {},
    importTemplate() {},
    changeRuleType(id) {
      if (id) {
        this.typeName = _.get(_.find(this.ruleClassList, { id }), 'displayName')
      } else {
        this.typeName = ''
      }
    },
    // 添加到任务-打开弹窗
    openAddDialog() {
      if (!this.attrSelectList.length) {
        this.$message.warning('请勾选属性规则！')
        return
      }
      this.dialogTask = true
      this.getTaskList()
    },
    // 获取任务列表
    async getTaskList() {
      this.taskLoading = true
      const res = await QualityTaskService.getList({
        pageno: this.taskpage.pageNo,
        pageSize: this.taskpage.pageSize,
      })
      this.taskLoading = false
      if (res && res.code === 0) {
        this.taskData = res.data
        this.taskpage.total = res.page ? res.page.recordCount : 0
      }
    },
    // 添加到任务-分页
    taskSizeChange(val) {
      this.taskpage.pageSize = val
      this.getTaskList()
    },
    // 添加到任务-分页
    taskNoChange(val) {
      this.taskpage.pageNo = val
      this.getTaskList()
    },
    // 添加到任务-保存
    async saveTaskData() {
      if (_.isEmpty(this.checkList)) {
        this.$message.warning('请选择任务进行添加')
        return
      }
      const params = {
        taskIds: _.map(this.checkList, 'id'),
        ruleIds: this.attrSelectList,
      }
      const res = await dataRuleSettingService.addToTask(params)
      if (res && res.code === 0) {
        this.$message.success('保存成功')
        this.dialogTask = false
        this.searchClass()
      }
    },
    // 添加到任务-点击行
    rowClick(row) {
      if (!_.find(this.checkList, { id: row.id })) {
        this.checkList.push(row)
        this.$refs.taskTable.toggleRowSelection(row, true)
      } else {
        this.checkList = _.filter(this.checkList, (item) => {
          return item.id !== row.id
        })
        this.$refs.taskTable.toggleRowSelection(row, false)
      }
    },
    // 添加到任务-勾选
    handleSelectionChange(val) {
      this.checkList = val
    },
    // 获取规则列表
    async getStategyList() {
      const res = await dataRuleSettingService.getStategyList()
      if (res && res.code === 0) {
        this.stategyList = res.data
      }
    },
    // 获取工作流列表
    async getWorkflowList() {
      const res = await dataRuleSettingService.getWorkflowList({
        TableId: this.currentEnv.VUE_APP_DIY_TABLE_ID,
        _PageSize: 999,
        _PageIndex: 1,
        _Where: [{ Name: 'FlowName', Value: '', Type: 'Like' }],
      })
      if (res && res.Code === 1) {
        this.workflowList = res.Data
      }
    },
    // 获取属性下拉数据
    async getAttrList() {
      const res = await dataRuleSettingService.getClassList({
        class_id: this.currentClassRow.classId,
      })
      if (res && res.code === 0) {
        this.attributeList = res.data
      }
    },
    clickClassRow(row) {
      this.currentClassRow = row
      this.searchAttr()
    },
  },
}
</script>

<style lang="scss" scoped>

.el-popper.tag_select-popper .el-select-dropdown__item {
  height: 100% !important;
  padding: 0;
}

</style>
